export default {
  contract_types: {
    key: 'contractType',
  },
  filter1: {
    key: 'filter1',
  },
  filter2: {
    key: 'filter2',
  },
  favorite_transports: {
    key: 'transportType',
  },
  services: {
    key: 'service',
  },
  seniorities: {
    key: 'seniority',
  },
};
